
import common from "./common";
import Qs from "qs";
import axios from "axios";

function request(params) {
  if (!params.url && !params.href) return;
  return new Promise((resolve, reject) => {
    let data = getParams(params);
    var root = location.origin;
    let headers =
      params.headers ||
      {
        // "Content-Type": "application/json;charset=UTF-8"
      };
    let method = params.type || "POST";
    method = method.toUpperCase();
    if (params.href) {
      params.url = params.href;
      root = "";
    }
    var token = localStorage.h5_token;
    // token = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwiaWF0IjoxNzI4NTY3MTc4LCJleHAiOjE4Mjg1NjcxNzh9.4tnMb_J9pTvf-qgjIwUundsApYTcFylv7Smf_sQzRzc'
    if (token) {
      headers["token"] = token;
    }
    if (common.token) {
      headers["token"] = common.token;
    }
    return axios({
      method: method,
      url: '/myproject' + params.url,
      data: method === "POST" || method === "PUT" ? data : null,
      params: method === "GET" || method === "DELETE" ? data : null,
      baseURL: root,
      headers: headers,
      onUploadProgress: params.onUploadProgress,
      /**end */
      withCredentials: true
    })
      .then(function (res) {
        if (params.hideAlert) {
          resolve(res.data);
          return;
        }
        let isErr = hasError(res.data, params);
        if (isErr) {
          reject(res.data);
        } else {
          resolve(res.data);
        }
      })
      .catch(function (err) {
        let res = err.response;
        reject(err);
        if(res.status == 401){
          localStorage.removeItem('h5_token');
          location.reload();
          return;
        }
        if (res) {
          window.alert("api error, HTTP CODE: " + res.status);
        }
      });
  });
}

// 接口参数校验和转换
function getParams(params) {
  let result;
  if (params.data) {
    result = filterNull(params.data);
  }
  if (params.contentType == "from") {
    result = getURLSearchParams(result);
  }
  return result;
}

//公共错误处理
function hasError(data, params) {
  if (data.code != 0) {
    setLayer(data.msg);
    document.getElementById("lz-readys").style.display = "none";
    return true;
  }
  return false;
}

function setLayer(msg) {
  window.alert(msg);
}
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
// 表单提交字段转换
function getURLSearchParams(params) {
  let data = Qs.stringify(params);
  return data;
}

export default request;
